<div class="hours-section" [ngClass]="{ 'multiple-hours': leaveHoursFormArray.controls.length > 1 }">
  <ng-container [formGroup]="group">
    @for (hoursSubmittal of leaveHoursFormArray.controls; track hoursSubmittal; let i = $index) {
      <div class="row__container" formArrayName="leaveHours">
        <ng-container [formGroupName]="i">
          <div class="field__container wrap">
            <div class="field-container">
              <mat-icon [ngClass]="{ focus: input.focused }">calendar_today</mat-icon>
              <mat-form-field color="accent">
                <mat-label>{{ sysText.requestDate | titlecase }}</mat-label>
                <input matInput [matDatepicker]="picker" [formControl]="hoursSubmittal.controls.requestDate" #input="matInput" (paste)="onPasteIntoField($event, i)" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker [touchUi]="isMobile"></mat-datepicker>
                <mat-hint class="hint-blue">
                  @if (hoursSubmittal.controls.sameDateWarn.value) {
                    <p class="mat-hint-combined">
                      {{ sysText.sameDateWarn }}
                    </p>
                  }
                  @if (hoursSubmittal.controls.workdayWarn.value) {
                    <p class="mat-hint-combined">
                      {{ hoursSubmittal.controls.workdayWarn.value }}
                    </p>
                  }
                </mat-hint>
                @if (hoursSubmittal.controls.requestDate.errors?.msError) {
                  <mat-error>{{ hoursSubmittal.controls.requestDate.errors?.msError }}</mat-error>
                }
                @if (hoursSubmittal.controls.requestDate.errors?.required && !hoursSubmittal.controls.requestDate.errors?.matDatepickerParse) {
                  <mat-error>{{ sysText.required | capitalizefirst }}</mat-error>
                }
                @if (hoursSubmittal.controls.requestDate.errors?.matDatepickerParse) {
                  <mat-error>{{ sysText.invalidDateError }}</mat-error>
                }
                @if (hoursSubmittal.controls.requestDate.errors?.dateRangeInvalid) {
                  <mat-error>{{ sysText.dateRangeInvalid1 + ' ' + (employeeCaseControl.value.startDate | date)  + ' ' + sysText.dateRangeInvalid2 + ' ' + (employeeCaseControl.value.endDate | date) }}.</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="field-container hours">
              <mat-form-field color="accent">
                <mat-label>{{ sysText.requestHours | titlecase }}</mat-label>
                <input matInput #input="matInput" type="number" [formControl]="hoursSubmittal.controls.requestHours" (paste)="onPasteIntoField($event, i)" autocomplete="off"/>
                <mat-hint class="hint-blue">
                  @if (hoursSubmittal.controls.workdayHoursWarn.value) {
                    <p class="mat-hint-combined">
                      {{ hoursSubmittal.controls.workdayHoursWarn.value }}
                    </p>
                  }
                  @if (hoursSubmittal.controls.notFullDayWarn.value === true) {
                    <p class="mat-hint-combined">
                      {{ sysText.notFullWorkdayError }}
                    </p>
                  }
                </mat-hint>
                @if (hoursSubmittal.controls.requestHours.errors?.msError) {
                  <mat-error>{{ hoursSubmittal.controls.requestHours.errors?.msError }}</mat-error>
                }
                @if (hoursSubmittal.controls.requestHours.errors?.required) {
                  <mat-error>{{ sysText.required | capitalizefirst }}</mat-error>
                }
                @if (hoursSubmittal.controls.requestHours.errors?.pattern) {
                  <mat-error>{{ sysText.invalidHoursError | capitalizefirst }}</mat-error>
                }
                @if (hoursSubmittal.controls.requestHours.errors?.hoursGreaterThan24) {
                  <mat-error>{{ sysText.hoursGreaterThan24Error | capitalizefirst }}</mat-error>
                }
              </mat-form-field>
            </div>
            @if (showFullDayControl) {
              <div class="check-container">
                <mat-checkbox
                  class="full-day-check"
                  [formControl]="hoursSubmittal.controls.isFullDay">{{ sysText.fullWorkday + (hoursSubmittal.controls.fullDayIncrement.value != null ? ' (' + hoursSubmittal.controls.fullDayIncrement.value + 'h' + ')'  : '') }}
                </mat-checkbox>
              </div>
            }
          </div>
          <div>
            @if (leaveHoursFormArray.controls.length > 1) {
              <button
                mat-icon-button
                [attr.aria-label]="sysText.remove_ariaLabel"
                type="button"
                [disableRipple]="true"
                (click)="onRemoveHoursSubmittal(i)">
                <mat-icon class="accent">close</mat-icon>
              </button>
            }
          </div>
        </ng-container>
      </div>
    }
  </ng-container>

  <div class="bottom-section">
    <div aria-live="polite">
      @if (leaveHoursFormArray.errors?.msError) {
        <mat-error class="mse-form-error caption bottom-hint">{{ leaveHoursFormArray.errors?.msError }}</mat-error>
      }
    </div>
    <div class="buttons-container" [ngClass]="{ 'multiple-hours': leaveHoursFormArray.controls.length > 1 }">
      <button
        #addHoursButton
        (click)="onAddHoursSubmittal()"
        mat-flat-button
        color="accent"
        type="button"
        class="button">
        {{sysText.addAdditionalHours | uppercase}}
      </button>
      <button
        (click)="onAddFromClipboard()"
        mat-flat-button
        color="accent"
        type="button"
        class="button"
        [disabled]="disableClipboardButton"
        [matTooltip]="disableClipboardButton ? sysText.addFromClipboardMessage : null"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        {{sysText.addFromClipboard | uppercase}}
      </button>
    </div>
  </div>
</div>